import React from "react";
import Modal from '../../component/Inc/Modal';
function PopConfirm(props) {
  const { open, close } = props;
  return (
    <Modal open={open} close={close} type="pop_confirm">
      <h2 className='pop_tit'>잔액 결정</h2>
      <div className="content_container scroll">
        <p className="notice_box">
          잔액이 <span className="point">120,000</span>원 있습니다.
        </p>
        <div className="check">
          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle"/>
          <label htmlFor="rdo_01">환불</label>
          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle"/>
          <label htmlFor="rdo_02">새로운 과목으로 이전</label>
          <input type="radio" name="rdo" id="rdo_03" className="com_chk circle"/>
          <label htmlFor="rdo_03">기존 과목으로 등록</label>
        </div>
        <select className="select">
          <option value="과목 선택">과목 선택</option>
          <option value="영어">영어</option>
        </select>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">확인</button>
      </div>
    </Modal>
  );
}

export default PopConfirm;